<chart-zoom [zoom]="zoom" [enableZoomScroll]="enableZoomScroll" (transform)="zoomed($event)" (trackEvent)="trackEvent.emit($event)">
  <svg class="svg-map" #svgContainer>
    <!--  This rect holds the zoom interactions -->
    <rect #rectZoom x="0" y="0" [attr.width]="size.width" [attr.height]="size.height" fill="white" fill-opacity="0" stroke="none"></rect>

    <!-- This wrapper applies the transformation from the zoom -->
    <g #shapeWrapper [attr.transform]="transform">
      <ng-template #chartShapeTemp let-shape>
        <g
          chart-shape
          [ngClass]="{
            excluded: shape.excluded,
            selected: shape.selected
          }"
          (mouseenter)="onHoverCountry(shape.id, $event)"
          (mouseleave)="onLeaveCountry()"
          [colors]="twoStepColors"
          [complementaryColors]="complementaryColors"
          [transform]="transform"
          [shape]="shape"
          [showBackground]="activateChoropleth"
          (click)="selected(shape)"
          [country]="dataCountriesMap[shape.id]"
          [dataRange]="dataRangeScaled ? dataRangeScaled : dataRange"
        ></g>
      </ng-template>

      <!-- SVG doesn't have z-index and we want "on selection" or "on exclusion" bring to the front the shape so need to render at the end what we want on the front -->

      <ng-container *ngFor="let shape of noHighlightedShapes">
        <ng-container *ngTemplateOutlet="chartShapeTemp; context: { $implicit: shape }"></ng-container>
      </ng-container>

      <ng-container *ngFor="let shape of excludedShapes">
        <ng-container *ngTemplateOutlet="chartShapeTemp; context: { $implicit: shape }"></ng-container>
      </ng-container>

      <ng-container *ngFor="let shape of selectedShapes">
        <ng-container *ngTemplateOutlet="chartShapeTemp; context: { $implicit: shape }"></ng-container>
      </ng-container>

      <!-- Bubble-->
      <ng-container *ngIf="worldmapTypesStatus.bubble">
        <ng-container *ngFor="let country of countries; trackBy: trackByCountry">
          <g
            chart-bubble
            *ngIf="worldFeaturesMap && worldFeaturesMap[country.id]"
            class="worldmap-symbol no-interaction"
            [circleSizes]="circleSizes"
            [color]="mainColor"
            [feature]="worldFeaturesMap[country.id]"
            [dataRange]="dataRangeScaled ? dataRangeScaled : dataRange"
            [country]="country"
          ></g>
        </ng-container>
      </ng-container>

      <!-- Pies-->
      <ng-container *ngIf="worldmapTypesStatus.pie">
        <ng-container *ngFor="let country of countries; trackBy: trackByCountry">
          <g
            chart-pie
            *ngIf="worldFeaturesMap && worldFeaturesMap[country.id] && categoryMap"
            class="worldmap-symbol no-interaction"
            [circleSizes]="circleSizes"
            [transform]="transform"
            [categoryMap]="categoryMap"
            [country]="country"
            [feature]="worldFeaturesMap[country.id]"
            [dataRange]="dataRangeScaled ? dataRangeScaled : dataRange"
          ></g>
        </ng-container>
      </ng-container>

      <!-- Symbols: GROWTH-->
      <ng-container *ngIf="worldmapTypesStatus.growth">
        <ng-container *ngFor="let country of countries; trackBy: trackByCountry">
          <g
            chart-symbol
            *ngIf="
              worldFeaturesMap && worldFeaturesMap[country.id] && countriesGrowthMap && countriesGrowthMap[country.id] && growthDataRange
            "
            class="worldmap-symbol no-interaction"
            [transform]="transform"
            [colors]="sequentialColors"
            [feature]="worldFeaturesMap[country.id]"
            [dataRange]="growthDataRange"
            [countryGrowth]="countriesGrowthMap[country.id]"
          ></g>
        </ng-container>
      </ng-container>
    </g>
  </svg>
</chart-zoom>

<!--  Legends -->
<ui-legend-box *ngIf="legendsActive && legendsActive.length" class="legend-box" [minimizedOnInit]="false" [data]="legendsActive">
  <ng-template #iconCollapsed>
    <div class="icon-legends2"></div>
  </ng-template>
</ui-legend-box>
<!--  Switch -->
<div class="switch-types">
  <div
    class="type-button"
    *ngFor="let type of worldMapTypes"
    [ngClass]="{ active: worldmapTypesStatus[type] }"
    (click)="changeWorldmapType(type)"
  >
    {{ 'chart-ng-worldmap.' + type | translate }}
  </div>
</div>

<!-- TOOLTIP! -->
<chart-worldmap-tooltip
  *ngIf="countryHovered"
  [ngStyle]="{
    width: tooltipWidth + 'px',
    transform: tooltipPosition + (tooltipAlignment === 'left' ? ' translate(-100%, 0)' : '')
  }"
  [categoryMap]="categoryMap"
  [country]="countryHovered"
></chart-worldmap-tooltip>
